import React, { Component } from "react";
import { FormControl, Button } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// No data found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// import paginationFactory from "react-bootstrap-table2-paginator";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import "../../routes/app";

import { customLog } from "../../variables/Variables";
import TagAudit from "../AuditTrail/TagAudit";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    tagManagementTitle: "Tag Management",
    tagDesc: "Shows all the tags of the selected lock",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    headerTagName: "Tag Name",
    headerTagId: "Tag ID",
    headerTimeAdded: "Time Added",
    confirmDeleteTitle: "Confirm remove tag",
    confirmDeleteMessage:
      "Tag will no longer be usable to the lock unless registered again",
    tagManagementTab: "Tag Management",
    tagAuditTab: "Tag Audit",
    removeSelectedBtn: "Remove Selected",
  },
  ja: {
    tagManagementTitle: "タグ管理",
    tagDesc: "選択したロックのすべてのタグを表示します",
    resultTitle1: "表示 ",
    resultTitle2: " へ ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    headerTagName: "タグ名",
    headerTagId: "タグID",
    headerTimeAdded: "追加時間",
    confirmDeleteTitle: "タグ削除の確認",
    confirmDeleteMessage:
      "タグは再登録しない限り、ロックでは使用できなくなります",
    tagManagementTab: "タグ管理",
    tagAuditTab: "タグ監査",
    removeSelectedBtn: "削除",
  },
  es: {
    tagManagementTitle: "Gestión de Etiquetas",
    tagDesc: "Muestra todas las etiquetas de la candado seleccionada",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    headerTagName: "Nombre de la Etiqueta",
    headerTagId: "ID de la Etiqueta",
    headerTimeAdded: "Hora Agregada",
    confirmDeleteTitle: "Confirmar eliminación de etiqueta",
    confirmDeleteMessage:
      "La etiqueta ya no será utilizable para la candado a menos que se registre nuevamente",
    tagManagementTab: "Gestión de Etiquetas",
    tagAuditTab: "Auditoría de Etiquetas",
    removeSelectedBtn: "Eliminar Seleccionados",
  },
});

class TagManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagListArray: [],
      lockListArray: [],
      selectedLockSerial: "",
      selectedRows: [],
      loading: true,
    };
    // console.log(this.state.tagListArray)
    // Deteching onChange
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);

    // Fetching of Data
    this.fetchTagListData = this.fetchTagListData.bind(this);
    // this.timeStampFormat = this.timeStampFormat.bind(this);

    //Editing of Data
    this.deleteTag = this.deleteTag.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    // this.handleOnSelect = this.handleOnSelect.bind(this)

    // Force Update
    // this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    // Force Update
    this.renderDropdown = this.renderDropdown.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);

    // Creating Buttons
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.renderSizePerPageDropDown = this.renderSizePerPageDropDown.bind(this);
    this.onToggleDropDown = this.onToggleDropDown.bind(this);
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  componentWillMount() {
    fire
      .database()
      .ref("MyAdminLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        this.setState({
          lockListArray: tempArray,
        });
      });
  }

  fetchTagListData(selectedLockSerial) {
    fire
      .database()
      .ref("tagDirectory")
      .child(selectedLockSerial)
      // .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        this.setState({
          tagListArray: tempArray,
        });
      });
  }

  // Render drop down list
  renderDropdown() {
    return _.map(this.state.lockListArray, (lockData) => {
      return (
        <option value={lockData.ip45SerialNumber}>
          {lockData.ip45SerialNumber}
        </option>
      );
    });
    // return _.map(this.state.historicalRecipientsArray, data => {
    //   return <option value={data.email}>{data.email}</option>;
    // });
  }

  detectOnChangeEvent(event) {
    var val = event.target.value;
    this.setState({
      selectedLock: val,
      count: 0,
    });
    var selectedLock = event.target.value;
    this.fetchTagListData(selectedLock);
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  // handleOnSelect(row, isSelect) {
  //     if (isSelect) {
  //         // console.log(row.tagId)
  //         console.log(isSelect)
  //         // console.log(rowIndex)
  //         // console.log(e)
  //         // this.setState(() => ({
  //         //     selectedRows: [...this.state.selectedRows, row.tagId]
  //         // }));
  //         this.setState({
  //             selectedRows: row.tagId
  //         })
  //         console.log(this.state.selectedRows)
  //     } else {
  //         console.log(isSelect)
  //         // // return false
  //         // this.setState(() => ({
  //         //     selectedRows: this.state.selectedRows.filter(x => x !== row.tagId)
  //         // }));
  //         // console.log(this.state.selectedRows)
  //     }
  // }

  createCustomDeleteButton = (onClick) => {
    return (
      <Button
        bsSize="large"
        id="retractableBtn"
        style={{ width: "100%" }}
        onClick={onClick}
      >
        <i className="far fa-trash-alt" />{" "}
        {localizationStrings.removeSelectedBtn}
      </Button>
    );
  };

  confirmDelete(next, dropRowKeys) {
    confirmAlert({
      title: localizationStrings.confirmDeleteTitle,
      message: localizationStrings.confirmDeleteMessage,
      buttons: [
        {
          label: "Confirm",
          onClick: () => next(),
        },
        {
          label: "Cancel",
          onClick: () => {
            return false;
          },
        },
      ],
    });
  }

  deleteTag(row) {
    customLog(row);
    customLog("TAG IS BEING DELETED");
    //TODO: Delete from nfcTagList
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder="Search"
      />
    );
  };

  onToggleDropDown = (toggleDropDown) => {
    // do your stuff here
    // console.log(toggleDropDown)
    // console.log('toggle dropdown');
    toggleDropDown();
  };

  renderSizePerPageDropDown = (props) => {
    return (
      <SizePerPageDropDown
        // className='my-size-per-page'
        // btnContextual='btn-warning'
        variation="dropup"
        onClick={() => this.onToggleDropDown(props.toggleDropDown)}
        {...props}
      />
    );
  };

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    function timeStampFormat(cell, row) {
      return <TimeStamp time={cell / 1000} format="full" includeDay />;
    }

    // const { SearchBar } = Search;

    const selectRow = {
      bgColor: "#eeeeee",
      mode: "checkbox",
      // clickToSelect: true
    };

    // const thArray = [
    //     {
    //         dataField: "name",
    //         text: "Tag Name",
    //         // (ハードウェア名)
    //         sort: true
    //     },
    //     {
    //         dataField: "tagId",
    //         text: "Tag Id",
    //         // (アクセス状況)
    //         sort: false
    //     },
    //     {
    //         dataField: "timeadded",
    //         text: "Time Added",
    //         // (アクセス状況)
    //         sort: true
    //     },
    // ];

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      paginationSize: 10,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      afterDeleteRow: this.deleteTag,
      handleConfirmDeleteRow: this.confirmDelete,
      deleteBtn: this.createCustomDeleteButton,
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: localizationStrings.nextPage,
      prePageTitle: localizationStrings.prePage,
      firstPageTitle: localizationStrings.firstPage,
      lastPageTitle: localizationStrings.lastPage,
      showTotal: true,
      paginationTotalRenderer: customTotal,
      noDataText: "No Data Found",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.tagListArray.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
      searchField: this.createCustomSearchField,
      // deleteBtn: this.createCustomDeleteButton
    };
    // console.log(this.state.tagListArray)

    return (
      <div
        className="content"
        style={{
          maxWidth: "95%",
          margin: "auto",
        }}
      >
        <div className="header">
          <h2>{localizationStrings.tagManagementTitle}</h2>
          {/* <h4>{localizationStrings.tagDesc}</h4> */}
        </div>
        <Tabs defaultIndex={0}>
          <TabList>
            <Tab>{localizationStrings.tagManagementTab}</Tab>
            <Tab>{localizationStrings.tagAuditTab}</Tab>
          </TabList>

          <TabPanel>
            <div>
              <div>
                {/* <ToolkitProvider
                            keyField="tagId"
                            data={tagListData}
                            columns={thArray}
                            search
                        > */}
                {/* {props => ( */}
                <div className="header">
                  <div
                    className="search"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <FormControl
                      style={{ width: "30%", marginTop: "32px" }}
                      className="content mediumDropDown"
                      componentClass="select"
                      placeholder="select"
                      onChange={this.detectOnChangeEvent}
                    >
                      <option value="showAll">Select Your Lock</option>
                      {this.renderDropdown()}
                    </FormControl>
                    {/* <SearchBar
                                            className="searchBar mediumSearchBar"
                                            style={{ marginTop: "30px" }}
                                            {...props.searchProps}
                                        /> */}
                  </div>
                  <br />
                  {/* <br /> */}

                  <BootstrapTable
                    // keyField="tagId"
                    id="table"
                    search
                    data={this.state.tagListArray}
                    // columns={thArray}
                    bordered={false}
                    options={options}
                    selectRow={selectRow}
                    deleteRow
                    loading={this.state.loading}
                    // overlay={overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' })}
                    noDataIndication={this.loadingData()}
                    // cellEdit={cellEditFactory({ mode: 'click' })}
                    pagination={true}
                    // pagination={paginationFactory(options)}
                    // {...props.baseProps}
                  >
                    <TableHeaderColumn
                      dataSort
                      dataField="tagName"
                      isKey={true}
                      hidden
                    />
                    <TableHeaderColumn
                      dataSort
                      dataField="tagName"
                      // editable={true}
                      // editable={this.state.isSuperAdmin}
                    >
                      {localizationStrings.headerTagName}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      // dataSort
                      dataField="tagId"
                      // editable={true}
                      // editable={this.state.isSuperAdmin}
                    >
                      {localizationStrings.headerTagId}
                    </TableHeaderColumn>
                    <TableHeaderColumn dataSort dataField="timeAdded" hidden />
                    <TableHeaderColumn
                      dataSort
                      dataField="timeAdded"
                      dataFormat={timeStampFormat}
                      // editable={true}
                      // editable={this.state.isSuperAdmin}
                    >
                      {localizationStrings.headerTimeAdded}
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
                {/* )} */}
                {/* </ToolkitProvider> */}
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <TagAudit />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(TagManagement);
